import { Component, Input } from '@angular/core';
import { NeskoAbAmtlicherWertDetailEntryMeta, NeskoAbVerteilerDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { of } from 'rxjs';
import { ListLoaderObservable } from 'app/shared/components/list-loader/list-loader-observable';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { KopfdatenelementComponent } from '../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { BeschreibungTableWrapperComponent } from '../../../shared/components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktNeskoabGrundstueckComponent } from '../../../shared/kompaktdarstellung/neskoab/kompakt-neskoab-grundstueck.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BetragPipe } from '../../../shared/pipes/simple/betrag.pipe';
import { DatumPipe } from '../../../shared/pipes/simple/datum.pipe';
import { DecimalHochkommaPipe } from '../../../shared/pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-nesko-amtliche-bewertung',
  templateUrl: './nesko-amtliche-bewertung.component.html',
  styleUrls: ['./nesko-amtliche-bewertung.component.scss'],
  imports: [
    RubrikComponent,
    KopfdatenelementComponent,
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    KompaktNeskoabGrundstueckComponent,
    TranslatePipe,
    BetragPipe,
    DatumPipe,
    DecimalHochkommaPipe
  ]
})
export class NeskoAmtlicheBewertungComponent {
  _awDetailEntry: NeskoAbAmtlicherWertDetailEntryMeta;

  listLoaderStammgrundstueck: ListLoader<NeskoAbVerteilerDetailEntryMeta>;

  listLoaderDominierteGs: ListLoader<NeskoAbVerteilerDetailEntryMeta>;

  @Input()
  hasRight = false;

  constructor() {
    keysToTranslate<string>([
      'neskoab.AmtlicherWertCHF',
      'neskoab.ErtragswertBGBB',
      'neskoab.GueltigAbSteuerjahr',
      'neskoab.Totalflaeche',
      'neskoab.AmtlicheBewertung',
      'neskoab.BasisRevision',
      'neskoab.Mutationsdatum',
      'neskoab.Mutationsgrund'
    ]);
  }

  @Input()
  set awDetailEntry(value: NeskoAbAmtlicherWertDetailEntryMeta) {
    if (!value) {
      return;
    }
    if (value.dominierteGrundstuecke) {
      this.listLoaderStammgrundstueck = this.getlistLoaderStammgrundstueck(value.dominierteGrundstuecke);
      this.listLoaderDominierteGs = this.getlistLoaderDominierteGs(value.dominierteGrundstuecke);
    } else {
      this.listLoaderStammgrundstueck = new ListLoaderObservable<NeskoAbVerteilerDetailEntryMeta>(undefined, 1, of([]));
    }
    this._awDetailEntry = value;
  }

  getlistLoaderStammgrundstueck(grundstuecke: Array<NeskoAbVerteilerDetailEntryMeta>): ListLoader<NeskoAbVerteilerDetailEntryMeta> {
    const temp = grundstuecke.filter((g) => g.showStammgrundstueck === true);
    return new ListLoaderObservable<NeskoAbVerteilerDetailEntryMeta>(undefined, 1, of(temp));
  }

  getlistLoaderDominierteGs(grundstuecke: Array<NeskoAbVerteilerDetailEntryMeta>): ListLoader<NeskoAbVerteilerDetailEntryMeta> {
    const temp = grundstuecke.filter((g) => g.showStammgrundstueck === false);
    return new ListLoaderObservable<NeskoAbVerteilerDetailEntryMeta>(undefined, 1, of(temp));
  }
}
